import get from 'lodash/get';

export const getIsPhone = (state) => {
  return get(state, 'device.isPhone', false);
};

export const getIsIpad = (state) => {
  return get(state, 'device.isIPad', false);
};

export const getIsTablet = (state) => {
  return get(state, 'device.isTablet', false);
};

export const getIsMobile = (state) => {
  return get(state, 'device.isMobile', false);
};
